import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { queryPicklistAction } from "../../../Engine/ActionCreators/PicklistActionCreators";
import { nonRegularFieldName } from "../../../Engine/Core/CoreTypes";
import { PicklistDataItem } from "../../../Engine/Core/Picklists/PicklistTypes";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { ControlDependency } from "../../withRuntimeDependencies";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { convertToLegacyPath } from "../../../../../Common/ModelPath/ModelPath";

import { Kladr, KladrField, ModelAddress } from "./Kladr";

interface KladrContainerProps {
    dependencies?: ControlDependency[];
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: KladrContainerProps) => {
    const { dependencies = [], viewModelSelect } = ownProps;
    let isTooltipEnabled = true;
    const address: ModelAddress = {
        index: "",
        building: "",
        city: "",
        district: "",
        house: "",
        regionCode: "",
        room: "",
        settlement: "",
        street: "",
        address: "",
    };
    let error: string | undefined = "";
    let warning: string | undefined = "";

    for (const { path, propName, valueName } of dependencies) {
        const partialAddress = viewModelSelect.pathViewModel(state, path);
        const fieldName = propName || valueName;

        // @ts-ignore в dependencies для kladr всегда есть valueName
        address[fieldName] = partialAddress[valueName];

        const controlModel = viewModelSelect.controlModel(state, path);

        isTooltipEnabled = controlModel.isTooltipEnabled;

        if (!error) {
            error = controlModel.error;
        }

        if (!warning) {
            warning = controlModel.warning;
        }
    }

    return {
        address: address,
        error: error,
        warning: warning,
        isTooltipEnabled: isTooltipEnabled,
        isReadOnly: state.settings.isReadOnly,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: KladrContainerProps) => {
    const { dependencies = [] } = ownProps;
    return {
        modelSet: (field: KladrField, value: string | null | undefined) => {
            const dependency = dependencies.find(({ valueName, propName }) =>
                propName ? propName === field : valueName === field
            );

            if (dependency && dependency.valueName != undefined) {
                dispatch(setToModel(dependency.path, nonRegularFieldName(dependency.valueName), value));
            }
        },
        onGetRegions: async (): Promise<PicklistDataItem[]> =>
            (await dispatch(queryPicklistAction({ gId: "17" }))).items,
    };
};

export const KladrContainer = withResolvePaths(
    withViewModelSelect(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(
            withFocusManagement(
                withExternalMountingEventReporting(Kladr),
                x => x.dependencies?.map(d => convertToLegacyPath(d.path)) ?? []
            )
        )
    )
);
